import * as React from 'react';

import * as styles from './UndergroundMapModalFooter.css';

export const UndergroundMapModalFooter: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles['footer']} data-testid="UndergroundPopupFooter">
    {children}
  </div>
);
